import { DynamicStyleSheet } from '@pulsar/core';

export const GAP = 8;

export default DynamicStyleSheet.create(theme => ({
  root: {
    flexDirection: 'row',
  },
  gap: {
    marginRight: GAP,
  },
}));
